// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { GroundTruthJobDebugInfo, IGroundTruthJobDebugInfo } from "./GroundTruthJobDebugInfo.gen";
import { GroundTruthJobStatus } from "./GroundTruthJobStatus.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";

export interface IGroundTruthResult {
	jobId: string | undefined;

	status: GroundTruthJobStatus;

	asOfDate: string | undefined;

	totalCount: number | undefined;

	countsByType: { [key: string]: number } | undefined;

	targetFilter: TargetTypes | number ;

	baselineUpdated: boolean;

	errorMessage: string | undefined;

	detail: IGroundTruthJobDebugInfo | undefined;

	$type?: string | undefined;
}
export class GroundTruthResult {
	constructor(data?: IGroundTruthResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.asOfDate) { this.asOfDate = new Date(data.asOfDate); }
		if (data.detail) { this.detail = new GroundTruthJobDebugInfo(data.detail); }
	}

	jobId: string | undefined;

	status: GroundTruthJobStatus = 0;

	asOfDate: Date | undefined = new Date();

	totalCount: number | undefined;

	countsByType: { [key: string]: number } | undefined;

	targetFilter: TargetTypes | number  = 0;

	baselineUpdated: boolean = false;

	errorMessage: string | undefined;

	detail: GroundTruthJobDebugInfo | undefined;

	static $type: string = "CoreApi.Models.GroundTruthResult, ";
	$type?: string | undefined = GroundTruthResult.$type;
}

